import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";
import { TablaTributo } from './modalTablaTributos';

import {validaSoloNumero} from '../../../util/varios'
import axios from "axios";


export const AgregarTributo = (props) => {

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem("jwtToken");


    

    /*  variables de estados */

    const btnCancela = useRef();
    const btnSiguiente = useRef();
    const txtDireccion = useRef();
    const [contar, setContar] = useState(0);
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [activate, setActivate] = useState(false);
    const [tipoTributo, setTipoTributo] = useState('0');
    const [nomid, setNomid] = useState('0');
    const [tecla, setTecla] = useState();
    const [comercios, setComercios] = useState([{idcomercio: '', nombre:'', direccion:''}]);
    const [inmuebles, setInmuebles] = useState([{idinmueble: '', nombre:'', direccion:''}]);
    const [vehiculos, setVehiculos] = useState([{idvehiculo: '', nombrepropie:'', marca:''}]); 
    const [values, setValues] = useState({
        codigo: '',
        txtCedula: '',
        txtNombre: '',
        txtDireccion: ''
    });

    const [inputDisabled, setInputDisabled] = useState({
        cedula: true,
        nombre: true,
        direccion: true,
        codigo: true
    });
    const [btnDisabled, setBtnDisabled] = useState(true);


    const onKeyTributo = (id) => {
        let campos = "*";
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${tipoTributo}&nomid=${nomid}`;
        setActivate(true);
    
        axios
          .get(endpoint, {
            headers: {
              "x-access-token": `${token}`,
            },
          })
          .then(function (response) {
            if (response.status == 200) {
              if (response.data !== "") {
               console.log(response.data)

              if(tipoTributo === 'inmueble'){
                setValues({
                    codigo: response.data.idinmueble ,
                    txtCedula: response.data.cedulapropie,
                    txtNombre: response.data.nombrepropie,
                    txtDireccion: response.data.descridirinmue1
                     });
              } else if( tipoTributo === 'comercio'){
                setValues({
                    codigo: response.data.idcomercio ,
                    txtCedula: response.data.rif,
                    txtNombre: response.data.nombre,
                    txtDireccion: response.data.direccion
                     });
              } else {
                setValues({
                    codigo: response.data.idvehiculo ,
                    txtCedula: response.data.cedulapropie,
                    txtNombre: response.data.nombrepropie,
                    txtDireccion: response.data.direccionpropie
                     });
              }

              setBtnDisabled(false)
        
              } else {
               
                if (tecla === 13) {
                  setTitulo("Error");
                  setMsg("El ",nomid," no existe.");
                  setMostrar(true);
                }
              }
            }
    
            setActivate(false);
          })
          .catch(function (error) {
            setTitulo("ERROR");
            setMsg(error.response.data.message);
            setMostrar(true);
            setActivate(false);
          });
    };

    const procesarRegistro = () => {

        let endpoint = `${op.conexion}/api/industria/agregartributo`;
        console.log(endpoint)

        let body ={

            operacion:1,
            iduser:parseInt(props.idusuarioweb.trim()),
            trib:tipoTributo,
            idtrib:parseInt(values.codigo.trim())

        }

        console.log(body)

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                props.onHideRenderizarTributos(props.idusuarioweb)
                setValues({
                    codigo: '' ,
                    txtCedula: '' ,
                    txtNombre: '',
                    txtDireccion: ''
                     });

                setActivate(false);
                setTitulo("NOTIFICACION");
                setMsg("Tributo agregado con exito!.");
                setMostrar(true);

            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }




      const validarContribuyente = (event) => {
        validaSoloNumero(event);
    
        if (event.which === 13 || typeof event.which === "undefined") {
            setTecla(event.which);
            onKeyTributo(event.target.value);
            
        }
      };

    /* metodo para restablecer los valores  a su estado inicial */

    const blanquear = () => {

        setValues({
            codigo: '',
            txtCedula: '',
            txtNombre: '',
            txtDireccion: ''
        });

        setInputDisabled({
            cedula: true,
            nombre: true,
            direccion: true,
            codigo: true
        });

        setBtnDisabled({
            aceptar: true,
            buscar: true
        });


        setMostrar(false);
        setTitulo('');
        setMsg('');
        setMostrar1(false);
        setTitulo1('');
        setMsg1('');
        setActivate(false);
        setTipoTributo('0');

    }

    /*  metodo para modificar la variable de estado values  */

    const onChange = (event) => {

        if (event.target.name === 'tipotributo') {

            blanquear();

            if (event.target.value === 'comercio') {

                setInputDisabled({ ...inputDisabled, codigo: false });
                setBtnDisabled({ ...btnDisabled, buscar: false });
                setTipoTributo('comercio');
                setNomid('idcomercio')

            } else if (event.target.value === 'inmueble') {

                setInputDisabled({ ...inputDisabled, codigo: false });
                setBtnDisabled({ ...btnDisabled, buscar: false });
                setTipoTributo('inmueble');
                setNomid('idinmueble')

            } else if (event.target.value === 'vehiculo') {

                setInputDisabled({ ...inputDisabled, codigo: false });
                setBtnDisabled({ ...btnDisabled, buscar: false });
                setTipoTributo('vehiculo');
                setNomid('idvehiculo')

            } else {

                setInputDisabled({ ...inputDisabled, codigo: true });
                setBtnDisabled({ ...btnDisabled, buscar: true });
                setTipoTributo('0');
            }

        } else {
            setValues({ ...values, [event.target.name]: event.target.value });

        }

    };

    const handleInputChange = (event) => {
        if (event.which === 13) {

            /* if (event.target.name === 'codigo') {

                if (tipoTributo === 'comercio') {
                    blanquear();
                    setTipoTributo('comercio');
                    llenarComercio(event.target.value);
                } else if (tipoTributo === 'inmueble') {
                    blanquear();
                    setTipoTributo('inmueble');
                    llenarInmueble(event.target.value);
                } else if (tipoTributo === 'vehiculo') {
                    blanquear();
                    setTipoTributo('vehiculo');
                    llenarVehiculo(event.target.value);
                }

            } */
        }
    }

/*     const agregarTributo = () => {
        client
        .mutate({
          mutation: AGREGAR_TRIBUTO, variables: { idusuarioweb: props.idusuarioweb, tributo: tipoTributo, idtributo: values.codigo }
        })
        .then(result => {    
            if (result.data.createMistributo.mistributo.idtributo !== null) {

                setTitulo('notificación');
                setMsg('Tributo agregado con exito!.');
                setMostrar(true);
            }

            setActivate(false); 
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión8.");
          setMostrar(true);
        });
      }

      const llenarComercio = (codigo) =>  {
        client
        .query({
          query: FETCH_COMERCIO, variables: { codigo: codigo }
        })
        .then(result => {    

            setValues({ codigo: result.data.comercioByIdcomercio.idcomercio, txtCedula: result.data.comercioByIdcomercio.cedulapropie, txtNombre: result.data.comercioByIdcomercio.nombre, txtDireccion: result.data.comercioByIdcomercio.direccion });
            validarTributo(result.data.comercioByIdcomercio.idcomercio);
           

            setActivate(false); 
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión7.");
          setMostrar(true);
        });
      } */

  /*   const tablaComercio = () => {
        client
        .query({
          query: FETCH_COMERCIOS
        })
        .then(result => {    

            setComercios(result.data.allComercios.nodes);
            setMostrar2(true);
            setActivate(false);
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión6.");
          setMostrar(true);
        });
      }
 */
/*     const llenarInmueble = (codigo) => {
        client
        .query({
          query: FETCH_INMUEBLE, variables: { codigo: codigo }
        })
        .then(result => {    

            setValues({ codigo: result.data.inmuebleByIdinmueble.idinmueble, txtCedula: result.data.inmuebleByIdinmueble.cedulapropie, txtNombre: result.data.inmuebleByIdinmueble.nombrepropie, txtDireccion: result.data.inmuebleByIdinmueble.dirpropie });
            validarTributo(result.data.inmuebleByIdinmueble.idinmueble);
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión5.");
          setMostrar(true);
        });
      } */

    /* const tablaInmueble = () => {
        client
        .mutate({
          mutation: FETCH_INMUEBLES
        })
        .then(result => {    

            setInmuebles(result.data.allInmuebles.nodes);
            setMostrar2(true);
            setActivate(false);

         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión2.");
          setMostrar(true);
        });
      } */

   /*  const llenarVehiculo = (codigo) => {
        client
        .query({
          query: FETCH_VEHICULO, variables: { codigo: codigo }
        })
        .then(result => {    

            setValues({ codigo: result.data.vehiculoByIdvehiculo.idvehiculo, txtCedula: result.data.vehiculoByIdvehiculo.cedulapropie, txtNombre: result.data.vehiculoByIdvehiculo.nombrepropie, txtDireccion: result.data.vehiculoByIdvehiculo.direccionpropie });
            validarTributo(result.data.vehiculoByIdvehiculo.idvehiculo);
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión0.");
          setMostrar(true);
        });
      }
 */
    
    /*   const tablaVehiculo = () => {
        client
        .query({
          query: FETCH_VEHICULOS
        })
        .then(result => {    

            setVehiculos(result.data.allVehiculos.nodes);
            setMostrar2(true);
            setActivate(false);
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión1.");
          setMostrar(true);
        });
      }
 */
    
   /*    const validarTributo = (codigo) => {
        client
        .mutate({
          mutation: VALIDAR_TRIBUTO, variables: { codigo: codigo }
        })
        .then(result => {   
                if (result.data.validartributo.respuestas.length === 0) {

                setBtnDisabled({ ...btnDisabled, aceptar: false });

            } else if(result.data.validartributo.respuestas[0] === props.idusuarioweb){

                setTitulo("notificación");
                setMsg("Usted ya tiene este Tributo registrado.");
                setMostrar(true);

            } else {

                setTitulo("notificación");
                setMsg("Este Tributo ya se encuentra registrado al usuario " + result.data.validartributo.respuestas[0]);
                setMostrar(true);

            }
      
         } ).catch(error => {
          setTitulo("notificación");
          setMsg("Error interno de Conexión validar.");
          setMostrar(true);
        });
      }
 */
   
 /*      const registrar = () => {

        if (values.codigo === '') {
            setTitulo('notificación');
            setMsg('El codigo del contribuyente no debe estar en blanco.');
            setMostrar(true);
        } else if (tipoTributo === ''||tipoTributo === '0') {

            setTitulo('notificación');
            setMsg('Introduzca un tributo valido.');
            setMostrar(true);

        } else {

            setTitulo1("confimación");
            setMsg1("Esta seguro de registrar este Tributo?");
            setMostrar1(true);

        }

    }; */

    /* metodo para confirmar el registro */

    const handleCloseSi = () => {
        setMostrar1(false);

        setActivate(true);
     /*    agregarTributo(); */

    };

    /* metodo para cancelar el registro */

    const handleCloseNo = () => {
        setMostrar1(false);
    };

    /* metodo para cerrar la notificacion */

    const handleCloseMensa = () => {

        setMostrar(false);

        if (msg === 'Tributo agregado con exito!.') {

    
           props.onHideCancela();

        } 

    }

    /* metodo para solo numeros */

    const valideKey = (event) => {

        if (event) {

            var key = window.event ? event.which : event.keyCode;
            if (key < 48 || key > 57) {

                event.preventDefault();

            }

            setValues({ ...values, [event.target.name]: event.target.value });
        }

    }


    const cancelar = () => {

        blanquear();
        props.onHideCancela();

    }

    const handleCancela2 = () => {
        setMostrar2(false);
      }


       const buscar = () => {

        if(tipoTributo !== '0'){
            setMostrar2(true)

        } else{
            setTitulo("NOTIFICACIÓN");
            setMsg("El Debe Seleccionar un Tipo de Tributo.");
            setMostrar(true);
        }

        
    }

      const seleccionar = (id,cedrif,nom,direc) => {

        setMostrar2(false);
        setValues({
            codigo: id,
            txtCedula: cedrif,
            txtNombre: nom,
            txtDireccion: direc
             });
        setBtnDisabled(false)

    }



    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor:"rgb(0, 0, 0,0.3)"}}
            backdrop="static"
            keyboard={false}
            onShow={() => { btnCancela.current.focus() }}
        >
            <Modal.Header className='azulGradiant'>
                Agregar Tributo
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="fas fa-times"></i>
                </button>
            </Modal.Header>
            <Modal.Body>

                <TablaTributo
                    show={mostrar2}
                    onHideCancela={handleCancela2}
                    tipoTributo={tipoTributo}
                    onHideRenderizar={seleccionar}
                    nomid={nomid} />

                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo1} mensaje={msg1}
                    show={mostrar1}
                    onHideNo={handleCloseNo} onHideSi={handleCloseSi} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='row mx-auto'>
                    <div className="input-group input-group-sm col-md-4 mb-1">
                        <span className="input-group-text" style={{ fontWeight: 'bold' }} id="inputGroup-sizing-sm">Tipo Tributo:</span>
                        <select className="form-select form-select-sm" onChange={onChange} name="tipotributo" value={tipoTributo}  >
                            <option value="0">-seleccione-</option>
                            <option value="comercio">comercio</option>
                            <option value="inmueble">inmueble</option>
                            <option value="vehiculo">vehiculo</option>

                        </select>
                    </div>
                    <div className='col-md-8'></div>

                  
                    <div className="col-md-12" style={{ padding: '10px', fontWeight: 'bold', fontSize: '18px' }}>
                        Detalles del Contribuyente
                        </div>
                  

                    <div className="input-group input-group-sm col-md-3 mb-1">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Código:</span>
                        <input type="text" name="codigo" value={values.codigo} onBlur={validarContribuyente} onKeyUp={validarContribuyente} onChange={onChange} className="form-control form-control-sm" id="validationTooltip01" disabled={inputDisabled.codigo} />
                        <button className="col-md-2 btn btn-info" onClick={buscar} /* onClick={buscar} disabled={btnDisabled.buscar}*/  ><i className="fas fa-search"></i></button>
                    </div>

                    <div className='col-md-5'></div>

                    <div className="input-group input-group-sm col-md-4 mb-1">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Cedula/Rif:</span>
                        <input type="text" value={values.txtCedula} disabled={inputDisabled.cedula} onChange={onChange} onKeyUp={handleInputChange} onBlur={handleInputChange} onKeyPress={valideKey} placeholder="123456789" autoComplete="off" name="txtCedula" min={0} maxLength={9} id="txtCedula" className="form-control text-uppercase" />
                        
                    </div>

                    <div className="input-group input-group-sm col-md-6 mb-1">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Nombre:</span>
                        <input name="txtNombre" disabled={inputDisabled.nombre} autoComplete="off" value={values.txtNombre} onKeyUp={handleInputChange} onChange={onChange} type="text" className="form-control text-uppercase" id="txtNombre" />
                        
                    </div>

                   

                    <div className="input-group input-group-sm col-md-6 mb-1">
                        <span className="input-group-text" id="inputGroup-sizing-sm">Dirección:</span>
                        <input name="txtDireccion" ref={txtDireccion} value={values.txtDireccion} disabled={inputDisabled.direccion} onKeyUp={handleInputChange} autoComplete="off" onChange={onChange} className="form-control text-uppercase" placeholder="ingrese su direccion" type="text" id="txtDireccion" />       
                    </div>


                       
           
                </div>

            </Modal.Body>
            <Modal.Footer >
                <button ref={btnSiguiente}  onClick={procesarRegistro}  disabled={btnDisabled} className="btn btn-sm btn-primary rounded-pill"><i className="fa">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}